import styled from 'styled-components';

export const ProductSlider = styled.section`
	margin-bottom: 3rem;
	padding: 2rem 0;

	@media only screen and (max-width: 37.5em) {
		height: 100vh;
		padding-bottom: 15rem;
	}
`;
